import { __rest } from "tslib";
import classnames from 'classnames';
import React from 'react';
import { icons } from './icons';
export const Icon = (_a) => {
    var { icon, color, iconSize, className } = _a, props = __rest(_a, ["icon", "color", "iconSize", "className"]);
    const sizeClass = iconSize ? `icon--${iconSize}` : null;
    const colorClass = color ? `icon--${color}` : null;
    const klass = classnames('icon', className, sizeClass, colorClass);
    const Ikon = icons[icon];
    if (!Ikon)
        return null;
    return React.createElement(Ikon, Object.assign({}, props, { className: klass }));
};
//# sourceMappingURL=index.js.map